module.exports = __webpack_public_path__ + "static/metaIcon-904119e143ec24c70fcb4b71cc437ccd.png";